
define('app/dashboard/leagues/instances/views/lgPositionAddView',[
	'jquery',
	'underscore',
	'backbone',
	'known/models/userModel',
	'known/models/leagueInstanceModel',
	'known/models/leagueUserModel',
	'known/models/leaguePositionModel',
	'known/models/productTypeModel'
], function(
		$, 
		_, 
		Backbone, 
		UserModel, 
		LeagueInstanceModel,
		LeagueUserModel,
		LeaguePositionModel,
		ProductTypeModel){

	var AddPositionFooterView = Backbone.View.extend({
		events: {
			'click #addPosFormSubmit': 'submitAddTeamForm',
		},
		
		initialize: function(options) {
			this.event = options.event;
			
			this.showAddForm();
			
			this.listenTo(this.event, 'default', this.showAddForm);
			this.listenTo(this.event, 'saving', this.hideAll);
			this.listenTo(this.event, 'error', this.showAddForm);
			this.listenTo(this.event, 'success', this.showAddForm);
		},
		
		hideAll: function () {
			this.$("#addPosFormSubmit").hide();
			this.$("#addPosFormCancel").hide();
		},
		
		submitAddTeamForm: function () {
			this.event.trigger("save");
		},
		
		showAddForm: function () {
			this.hideAll();
			this.$("#addPosFormSubmit").show();
			this.$("#addPosFormCancel").show();
		},
	    
	    destroyView: function() {
	    	this.stopListening();
	    	this.undelegateEvents();
        }
	});

	var AddPositionContentView = Backbone.View.extend({
		initialize: function(options) {
			this.hideAll();
			
			this.event = options.event;
			this.submittedData = options.submittedData;
			this.userModel = options.userModel; 
			this.lgInstance = options.lgInstance;
			this.prodType = options.prodType;
			
			this.defaultColorList = [
			                         '#fea3aa','#ff4040','#bc2626', //red
			                         '#a9dba9','#39e639','#22ab22', //green
			                         '#ffe9a6','#ffff00','#8f8f00',//yellow
			                         '#7bd7fd','#4671d5','#274b9f', //blue
			                         '#f2a2e8','#9f3ed5','#73239f', //purple
			                         '#fbbf69','#ffaa00','#8f5f00', //orange
			                         '#ffffff','#bbbbbb','#000000']; //white/black
			
			this.editInput = $(this.el).find('#addPosColorInput');
			this.editColorDisplay = $(this.el).find('#positionColorAddDisplay');			
			this.defaultPreviewDivs = $(this.el).find('#colorDefaultPreviews');
			
			this.initPosData();
			
			_.bindAll(this, 'successCallback');
			_.bindAll(this, 'errorCallback');
			_.bindAll(this, 'updateColor');
			_.bindAll(this, 'defaultSelected');
			_.bindAll(this, 'changePosOptions');
			
			this.listenTo(this.event, 'save', this.submitAddPosition);
			this.listenTo(this.event, 'default', this.hideAll);
			this.listenTo(this.event, 'saving', this.hideAll);
			this.listenTo(this.event, 'error', this.addPositionForm);
			this.listenTo(this.event, 'success', this.success);
			
			this.editInput.on('keyup', this.updateColor);
			this.$('input[type=radio][name=addPosType]').on("change", this.changePosOptions);
			
			this.listenTo(this.lgInstance, 'remove:leaguePositions', this.updateInputs);
			this.listenTo(this.lgInstance, 'add:leaguePositions', this.updateInputs);
			
			//Error handling
			this.listenTo(this.event, 'error:name', this.errorPosition);
			this.listenTo(this.event, 'error:positions', this.errorPosition);
			this.listenTo(this.event, 'error:starters', this.errorStarters);
			this.listenTo(this.event, 'error:color', this.errorColor);
			this.listenTo(this.event, 'error:min', this.errorMin);
			this.listenTo(this.event, 'error:max', this.errorMax);
			
			//Initialize fields
			this.buildEl();
		},
		
		buildEl: function() {
			var previewRowDiv = $('<div class="dropdownDivItem posPreviewRow"></div>');
			
			for(var i=0; i < this.defaultColorList.length; i++) {
				if(i%3 == 0){
					if(i>0){
						this.defaultPreviewDivs.append(previewRowDiv);
					}
					
					previewRowDiv = $('<div class="dropdownDivItem posPreviewRow"></div>');
				}
				
				var previewDiv = $('<div class="posPreviewRowItem">&nbsp;</div>');
				
				previewDiv.css({ "background-color": this.defaultColorList[i]});
				previewDiv.on('click', {hexColor: this.defaultColorList[i]}, this.defaultSelected);
				previewRowDiv.append(previewDiv);
			}
			
			this.defaultPreviewDivs.append(previewRowDiv);
			this.updateColor();
			
			switch (this.lgInstance.get('prodLeagueName')) {
			case 'NFL':
				this.$("#addPosTypeIDPRadio").show();
				this.$("#addPosTypeFRadio").hide();
				this.$("#addPosTypeGRadio").hide();
				this.$("#addPosTypeOFRadio").hide();
				this.$("#addPosTypePRadio").hide();
				this.$("#addPosTypeUtilRadio").hide();
				break;
			case 'MLB':
				this.$("#addPosTypeIDPRadio").hide();
				this.$("#addPosTypeFRadio").hide();
				this.$("#addPosTypeGRadio").hide();
				this.$("#addPosTypeOFRadio").show();
				this.$("#addPosTypePRadio").show();
				this.$("#addPosTypeUtilRadio").show();
				break;
			case 'NBA':
				this.$("#addPosTypeIDPRadio").hide();
				this.$("#addPosTypeFRadio").show();
				this.$("#addPosTypeGRadio").show();
				this.$("#addPosTypeOFRadio").hide();
				this.$("#addPosTypePRadio").hide();
				this.$("#addPosTypeUtilRadio").hide();
				break;
			case 'NHL':
				this.$("#addPosTypeIDPRadio").hide();
				this.$("#addPosTypeFRadio").show();
				this.$("#addPosTypeGRadio").hide();
				this.$("#addPosTypeOFRadio").hide();
				this.$("#addPosTypePRadio").hide();
				this.$("#addPosTypeUtilRadio").hide();
				break;
			default:
				break;
			}
				
		},
		
		updateColor: function() {
			var inputVal = this.editInput.val();
			
			if(!inputVal || inputVal.length < 3){
				this.errorColor("LENGTH");
				return false;
			}
			
			if(inputVal.charAt(0) == "#"){
				inputVal = inputVal.substr(1);
			}
			
			var hexColorRegex = /^#?(([0-9a-fA-F]{2}){3}|([0-9a-fA-F]){3})$/; 
			
			if(hexColorRegex.test(inputVal)){
				this.editColorDisplay.css({ "background-color": '#' + inputVal});
				this.hideColorError();
				
				return '#' + inputVal;
			} else {
				this.errorColor("COLORHEX");
				
				return null;
			}
			
		},
		
		defaultSelected: function(event){
			this.editInput.val(event.data.hexColor);
			this.updateColor();
		},
		
		render: function() {
			this.updateInputs();
			
			return true;
		},
		
		submitAddPosition: function () {
			if(!this.submittedData.isSubmitted){
				var addPosType = this.$('input[name=addPosType]:checked').val();
				var posArr = [];
				var name = "";
				
				switch (addPosType) {
				case "SINGLE":
					name = this.$('input[name=addPosPosition]:checked').val();
					posArr.push(this.$('input[name=addPosPosition]:checked').val()); 
					break;
				case "IDP":
					name = "IDP";
					posArr.push('DL');
					posArr.push('LB');
					posArr.push('DB');
					break;
				case "G":
					name = "G";
					posArr.push('PG');
					posArr.push('SG');
					posArr.push('G');
					break;
				case "F":
					name = "F";
					if(this.lgInstance.get("prodLeagueName") == 'NBA') {
						posArr.push('SF');
						posArr.push('PF');
						posArr.push('F');
					} else if(this.lgInstance.get("prodLeagueName") == 'NHL'){
						posArr.push('C');
						posArr.push('LW');
						posArr.push('RW');
					}
					break;
				case "OF":
					name = "OF";
					posArr.push('RF');
					posArr.push('CF');
					posArr.push('OF');
					posArr.push('LF');
					break;
				case "P":
					name = "P";
					posArr.push('P');
					posArr.push('RP');
					posArr.push('SP');
					break;
				case "MI":
					name = "MI";
					posArr.push('2B');
					posArr.push('SS');
					break;
				case "CI":
					name = "CI";
					posArr.push('1B');
					posArr.push('3B');
					break;
				case "UTIL":
					name = "UTIL";
					posArr.push('SS');
					posArr.push('RF');
					posArr.push('3B');
					posArr.push('CF');
					posArr.push('C');
					posArr.push('2B');
					posArr.push('OF');
					posArr.push('1B');
					posArr.push('LF');
					posArr.push('DH');
					break;
				case "FLEX":
					name = "FLEX";
					posArr = _.map($("input[name='addPosPositions']:checked"), function(el){return $(el).val();});
					
					if(posArr.length < 2){
						this.errorPosition("MIN");
						return;
					}
					
					this.positionExists = false;
					this.arr = posArr;
					this.lgInstance.get("leaguePositions").each(function(position){
						if(position.get('positions').length == this.arr.length){
							var isSame = true;
							for (var i = 0; i < position.get('positions').length; i++) {
								isSame = isSame && _.contains(this.arr, position.get('positions')[i]);
							}
							
							if(isSame){
								this.positionExists = true;
							}
						}
					}, this);
					
					if(this.positionExists){
						this.errorPosition("UNIQUE");
						return;
					}
					
					break;

				default:
					this.errorType("NULL");
					return;
					break;
				}
				
				var min = parseInt(this.$("#addPosMinInput").val());
				var max = parseInt(this.$("#addPosMaxInput").val());
				var starters = parseInt(this.$("#addPosStartersInput").val());
				
				if(min > max){
					this.errorMax("MIN");
				} else if (starters > max){
					this.errorMax("STARTERS");
				} else {
					this.event.trigger("saving");
					
					this.submittedData.isSubmitted = true;
					
					
					var addedPosition = new LeaguePositionModel({
						name: name,
						color: this.$("#addPosColorInput").val(),
						min: min,
						max: max,
						starters: starters,
						positions: posArr
					},{
						lgInstId: this.lgInstance.get('id'),
						lgId: this.lgInstance.get('leagueId'),
						prodLgName: this.lgInstance.get('prodLeagueName')});
					addedPosition.save({}, {wait: true, success: this.successCallback, error: this.errorCallback});
				}
			}
		},
		
		updateInputs: function() {
			$("input[name=addPosType]").prop("checked", false);
			
			
			this.idpExists = false;
			this.gExists = false;
			this.fExists = false;
			this.ofExists = false;
			this.pExists = false;
			this.miExists = false;
			this.ciExists = false;
			this.utilExists = false;
			this.openPosCount = 0;
			this.usedPositions = {};
			
			$('#addPosPositionsContainer').empty();
			$('#addPosPositionContainer').empty();
			
			for (var i = 0; i < this.posData.length; i++) {
				this.usedPositions[this.posData[i]] = false;				
			}
			
			this.lgInstance.get("leaguePositions").each(function(position){
				if(position.get('name') == 'IDP'){
					this.idpExists = true;
				} else if(position.get('name') == 'G'){
					this.gExists = true;
				} else if(position.get('name') == 'F'){
					this.fExists = true;
				} else if(position.get('name') == 'OF'){
					this.ofExists = true;
				} else if(position.get('name') == 'P'){
					this.pExists = true;
				} else if(position.get('name') == 'MI'){
					this.miExists = true;
				} else if(position.get('name') == 'CI'){
					this.ciExists = true;
				} else if(position.get('name') == 'UTIL'){
					this.utilExists = true;
				}				
				
				if(position.get('positions').length == 1){
					this.usedPositions[position.get('positions')[0]] = true;
				}
			}, this);
			
			if(this.lgInstance.get('prodLeagueName') == 'NBA'){
				this.usedPositions['G'] = true;
				this.usedPositions['F'] = true;
			} else if(this.lgInstance.get('prodLeagueName') == 'MLB'){
				this.usedPositions['OF'] = true;
				this.usedPositions['P'] = true;
			} 
			
			for(var pos in this.usedPositions) {
				if(this.usedPositions[pos] == false){
					this.openPosCount++;
					
					$('#addPosPositionContainer').append(
							'<label class="radio"><input type="radio" name="addPosPosition" class="styled" value="'
							+ pos
							+ '">'
							+ pos
							+ '</label>');
				}
				
				$('#addPosPositionsContainer').append(
						'<label class="checkbox"><input type="checkbox" name="addPosPositions" class="styled" value="'
						+ pos
						+ '">'
						+ pos
						+ '</label>');
			}
			
			if(this.openPosCount == 0){
				this.$("#addPosTypeSingle").prop('disabled', 'disabled'); // Input
				this.$("#addPosTypeSingleRadio").addClass('disabled'); // Label
			} else {
				this.$("#addPosTypeSingle").removeProp('disabled');
				this.$("#addPosTypeSingleRadio").removeClass('disabled');
			}
			
			if(this.lgInstance.get('prodLeagueName') == 'NFL'){
				if(this.idpExists) {
					this.$("#addPosTypeIDP").prop('disabled', 'disabled'); // Input
					this.$("#addPosTypeIDPRadio").addClass('disabled'); // Label
				} else {
					this.$("#addPosTypeIDP").removeProp('disabled');
					this.$("#addPosTypeIDPRadio").removeClass('disabled');
				}
			} else if(this.lgInstance.get('prodLeagueName') == 'MLB'){
				if(this.ofExists) {
					this.$("#addPosTypeOF").prop('disabled', 'disabled'); // Input
					this.$("#addPosTypeOFRadio").addClass('disabled'); // Label
				} else {
					this.$("#addPosTypeOF").removeProp('disabled');
					this.$("#addPosTypeOFRadio").removeClass('disabled');
				}
				
				if(this.pExists) {
					this.$("#addPosTypeP").prop('disabled', 'disabled'); // Input
					this.$("#addPosTypePRadio").addClass('disabled'); // Label
				} else {
					this.$("#addPosTypeP").removeProp('disabled');
					this.$("#addPosTypePRadio").removeClass('disabled');
				}
				
				if(this.miExists) {
					this.$("#addPosTypeMI").prop('disabled', 'disabled'); // Input
					this.$("#addPosTypeMIRadio").addClass('disabled'); // Label
				} else {
					this.$("#addPosTypeMI").removeProp('disabled');
					this.$("#addPosTypeMIRadio").removeClass('disabled');
				}
				
				if(this.ciExists) {
					this.$("#addPosTypeCI").prop('disabled', 'disabled'); // Input
					this.$("#addPosTypeCIRadio").addClass('disabled'); // Label
				} else {
					this.$("#addPosTypeCI").removeProp('disabled');
					this.$("#addPosTypeCIRadio").removeClass('disabled');
				}
				
				if(this.utilExists) {
					this.$("#addPosTypeUtil").prop('disabled', 'disabled'); // Input
					this.$("#addPosTypeUtilRadio").addClass('disabled'); // Label
				} else {
					this.$("#addPosTypeUtil").removeProp('disabled');
					this.$("#addPosTypeUtilRadio").removeClass('disabled');
				}
			} else if(this.lgInstance.get('prodLeagueName') == 'NBA'){
				if(this.gExists) {
					this.$("#addPosTypeG").prop('disabled', 'disabled'); // Input
					this.$("#addPosTypeGRadio").addClass('disabled'); // Label
				} else {
					this.$("#addPosTypeG").removeProp('disabled');
					this.$("#addPosTypeGRadio").removeClass('disabled');
				}
				
				if(this.fExists) {
					this.$("#addPosTypeF").prop('disabled', 'disabled'); // Input
					this.$("#addPosTypeFRadio").addClass('disabled'); // Label
				} else {
					this.$("#addPosTypeF").removeProp('disabled');
					this.$("#addPosTypeFRadio").removeClass('disabled');
				}
			} else if(this.lgInstance.get('prodLeagueName') == 'NHL'){
				if(this.fExists) {
					this.$("#addPosTypeF").prop('disabled', 'disabled'); // Input
					this.$("#addPosTypeFRadio").addClass('disabled'); // Label
				} else {
					this.$("#addPosTypeF").removeProp('disabled');
					this.$("#addPosTypeFRadio").removeClass('disabled');
				}
			}
			
			$(this.el).find('.styled').uniform({radioClass: 'choice', selectAutoWidth: false});
			this.changePosOptions();
		},
		
		changePosOptions: function() {
			var addPosType = this.$('input[name=addPosType]:checked').val();
			
			switch (addPosType) {
			case "SINGLE":
				this.$("#addPosPositionsGrp").hide();
				this.$("#addPosPositionGrp").show();
				break;
			case "IDP":
			case "G":
			case "F":
			case "OF":
			case "P":
			case "UTIL":
			case "MI":
			case "CI":
				this.$("#addPosPositionsGrp").hide();
				this.$("#addPosPositionGrp").hide();
				break;
			case "FLEX":
				this.$("#addPosPositionsGrp").show();
				this.$("#addPosPositionGrp").hide();
				break;
			default:
				this.$("#addPosPositionsGrp").hide();
				this.$("#addPosPositionGrp").hide();
				break;
			}
		},
		
		initPosData: function() {
			switch (this.lgInstance.get('prodLeagueName')) {
			case 'NFL':
				this.posData = ['QB','RB','WR','TE','PK','DEF','DL','LB','DB','HC','P','OL'];
				break;
			case 'MLB':
				this.posData = ["SP","RP","P","C","1B","2B","SS","3B","LF","CF","RF","OF","DH","HC"];				
				break;
			case 'NBA':
				this.posData = ["PG","SG","G","SF","PF","F","C","HC"];				
				break;
			case 'NHL':
				this.posData = ["C","LW","RW","D","G","HC"];
				break;
			default:
				break;
			}
		},
		
		successCallback: function(model, response) {
			this.event.trigger("savingSuccess", model, response);
		},
		
		errorCallback: function(model, error) {
			this.event.trigger("savingError", model, error);
		},
		
		hideAll: function() {
			$(this.el).hide();
			
			//Hide error messages
			this.$("#addPosTypeGrp").removeClass("error");
			this.$("#addPosTypeErrMsg").hide();
			
			this.$("#addPosPositionsGrp").removeClass("error");
			this.$("#addPosPositionsErrMsg").hide();
			
			this.$("#addPosPositionGrp").removeClass("error");
			this.$("#addPosPositionErrMsg").hide();
			
			this.$("#addPosStartersGrp").removeClass("error");
			this.$("#addPosStartersInput").removeClass("error");
			this.$("#addPosStartersErrMsg").hide();
			
			this.$("#addPosMinGrp").removeClass("error");
			this.$("#addPosMinInput").removeClass("error");
			this.$("#addPosMinErrMsg").hide();
			
			this.$("#addPosMaxGrp").removeClass("error");
			this.$("#addPosMaxInput").removeClass("error");
			this.$("#addPosMaxErrMsg").hide();
			
			this.hideColorError();
		},
		
		hideColorError: function() {
			this.$("#addPosColorGrp").removeClass("error");
			this.$("#addPosColorInput").removeClass("error");
			this.$("#addPosColorErrMsg").hide();
		},
		
		addPositionForm: function () {
			this.hideAll();
			$(this.el).show();
		},
		
		success: function () {
			this.hideAll();
			this.$("#addPosColorInput").val('#bbbbbb');
			this.$("#addPosMinInput").val('0');
			this.$("#addPosMaxInput").val('99');
			this.$("#addPosStartersInput").val('0');
			
			this.editColorDisplay.css({ "background-color": '#bbbbbb'});
		},
		
		errorType : function (errorCode) {
			this.$("#addPosTypeGrp").addClass("error");
			switch (errorCode){
				case "NULL": 
					this.$("#addPosTypeErrMsg").html("Position type is empty");
					this.$("#addPosTypeErrMsg").show();
					break;
				default : 
					this.$("#addPosTypeErrMsg").html("Position type is invalid");
					this.$("#addPosTypeErrMsg").show();
			}
		},
		
		errorPosition : function (errorCode) {
			switch (errorCode){
				case "NULL":
					this.$("#addPosPositionsGrp").addClass("error");
					this.$("#addPosPositionGrp").addClass("error");
					this.$("#addPosPositionsErrMsg").html("Positions is empty");
					this.$("#addPosPositionsErrMsg").show();
					this.$("#addPosPositionErrMsg").html("Position is empty");
					this.$("#addPosPositionErrMsg").show();
					break;
				case "MIN":
					this.$("#addPosPositionsGrp").addClass("error");
					this.$("#addPosPositionsErrMsg").html("At least two positions must be selected");
					this.$("#addPosPositionsErrMsg").show();
					break;
				case "UNIQUE":
					this.$("#addPosPositionsGrp").addClass("error");
					this.$("#addPosPositionsErrMsg").html("Position combination already exists. Try editing position instead.");
					this.$("#addPosPositionsErrMsg").show();
					break;
				default : 
					this.$("#addPosPositionsGrp").addClass("error");
					this.$("#addPosPositionGrp").addClass("error");
					this.$("#addPosPositionsErrMsg").html("Positions is invalid");
					this.$("#addPosPositionsErrMsg").show();
					this.$("#addPosPositionErrMsg").html("Position is invalid");
					this.$("#addPosPositionErrMsg").show();
			}
		},
		
		errorStarters : function (errorCode) {
			this.$("#addPosStartersGrp").addClass("error");
			this.$("#addPosStartersInput").addClass("error");
			switch (errorCode){
				case "NULL": 
					this.$("#addPosStartersErrMsg").html("Number of Starters is empty");
					this.$("#addPosStartersErrMsg").show();
					break;
				case "LENGTH":
					this.$("#addPosStartersErrMsg").html("Number of starters must be between 1 and 99");
					this.$("#addPosStartersErrMsg").show();
					break;
				case "NUMERIC":
					this.$("#addPosStartersErrMsg").html("Number of starters may only contain numeric characters");
					this.$("#addPosStartersErrMsg").show();
					break;
				default : 
					this.$("#addPosStartersErrMsg").html("Number of starters is invalid");
					this.$("#addPosStartersErrMsg").show();
			}
		},
		
		errorColor : function (errorCode) {
			this.$("#addPosColorGrp").addClass("error");
			this.$("#addPosColorInput").addClass("error");
			switch (errorCode){
				case "NULL": 
					this.$("#addPosColorErrMsg").html("Position color is empty");
					this.$("#addPosColorErrMsg").show();
					break;
				case "LENGTH": 
					this.$("#addPosColorErrMsg").html("Position color hex must be at least 3 characters long");
					this.$("#addPosColorErrMsg").show();
					break;
				case "COLORHEX":
					this.$("#addPosColorErrMsg").html("Position color must be in hexadecimal format (ex: #fff or #ffffff)");
					this.$("#addPosColorErrMsg").show();
					break;
				default : 
					this.$("#addPosColorErrMsg").html("Position color is invalid");
					this.$("#addPosColorErrMsg").show();
			}
		},
		
		errorMin : function (errorCode) {
			this.$("#addPosMinGrp").addClass("error");
			this.$("#addPosMinInput").addClass("error");
			switch (errorCode){
				case "NULL": 
					this.$("#addPosMinErrMsg").html("Minimum number of players is empty");
					this.$("#addPosMinErrMsg").show();
					break;
				case "LENGTH":
					this.$("#addPosMinErrMsg").html("Minimum number of players must be between 1 and 99");
					this.$("#addPosMinErrMsg").show();
					break;
				case "NUMERIC":
					this.$("#addPosMinErrMsg").html("Minimum number of players may only contain numeric characters");
					this.$("#addPosMinErrMsg").show();
					break;
				default : 
					this.$("#addPosMinErrMsg").html("Minimum number of players is invalid");
					this.$("#addPosMinErrMsg").show();
			}
		},
		
		errorMax : function (errorCode) {
			this.$("#addPosMaxGrp").addClass("error");
			this.$("#addPosMaxInput").addClass("error");
			switch (errorCode){
				case "NULL": 
					this.$("#addPosMaxErrMsg").html("Max number of players is empty");
					this.$("#addPosMaxErrMsg").show();
					break;
				case "LENGTH":
					this.$("#addPosMaxErrMsg").html("Max number of players must be between 1 and 99");
					this.$("#addPosMaxErrMsg").show();
					break;
				case "NUMERIC":
					this.$("#addPosMaxErrMsg").html("Max number of players may only contain numeric characters");
					this.$("#addPosMaxErrMsg").show();
					break;
				case "MIN":
					this.$("#addPosMaxErrMsg").html("Max number of players must be less than the minimum number of players");
					this.$("#addPosMaxErrMsg").show();
					break;
				case "STARTERS":
					this.$("#addPosMaxErrMsg").html("Max number of players must be less than the number of starters");
					this.$("#addPosMaxErrMsg").show();
					break;
				default : 
					this.$("#addPosMaxErrMsg").html("Max number of players is invalid");
					this.$("#addPosMaxErrMsg").show();
			}
		},
	    
	    destroyView: function() {
	    	this.stopListening();
	    	this.undelegateEvents();
        }
	});

	var AddPositionMessageView = Backbone.View.extend({
		initialize: function(options) {
			this.hideAll();
			
			this.event = options.event;
			
			this.listenTo(this.event, 'default', this.hideAll);
			this.listenTo(this.event, 'resetMessages', this.hideAll);
			this.listenTo(this.event, 'saving', this.processing);
			this.listenTo(this.event, 'error', this.error);
			this.listenTo(this.event, 'success', this.addSuccess);
		},
		
		hideAll: function() {
			$(this.el).hide();
			this.$("#addPosBodyMessageError").hide();
			this.$("#addPosBodyMessageProcessing").hide();
			this.$("#addPosBodyMessageSuccess").hide();
		},
		
		error: function () {
			this.hideAll();
			$(this.el).show();
			this.$("#addPosBodyMessageError").show();
		},
		
		addSuccess: function () {
			this.hideAll();
			$(this.el).show();
			this.$("#addPosBodyMessageSuccess").show();
			this.$("#addPosBodyMessageSuccess").fadeOut(3000);
		},
		
		processing: function () {
			this.hideAll();
			$(this.el).show();
			this.$("#addPosBodyMessageProcessing").show();
		},
	    
	    destroyView: function() {
	    	this.stopListening();
	    	this.undelegateEvents();
        }
	});
	
	var AddPositionView = Backbone.View.extend({
		el: $("#addPosContent"),
		
		initialize: function(options) {
			this.userModel = options.userModel; 
			this.lgInstance = options.lgInstance;
			this.prodType = options.prodType;
			this.prodConfig = options.prodConfig;
			
			this.event = _.extend({}, Backbone.Events);
			this.submittedData = {isSubmitted : false};
			
			_.bindAll(this, 'hideView');
			_.bindAll(this, 'showView');
			_.bindAll(this, 'formSubmit');
			
			this.message = new AddPositionMessageView({el: this.$("#addPosBodyMessage"), event: this.event});
			this.content = new AddPositionContentView({
					el: this.$("#addPosBodyContent"), 
					event: this.event,
					submittedData : this.submittedData,
					userModel: this.userModel, 
					lgInstance: this.lgInstance,
					prodType: this.prodType});
			this.footer = new AddPositionFooterView({el: this.$("#addPosFooter"), event: this.event});
			
			this.listenTo(this.event, 'savingSuccess', this.success);
			this.listenTo(this.event, 'savingError', this.error);
			
			//this.listenTo(this.lgInstance, 'change:draftStatus', this.updateVisuals);
			
			//Setup Form open/hide
			var addPosOpenBtn = this.$("#addPosOpen");
			var addPosCloseBtn = this.$("#addPosFormCancel");
			
			addPosOpenBtn.on('click', {}, this.showView);
			addPosCloseBtn.on('click', {}, this.hideView);
			this.$("#addPosBodyContent").submit(this.formSubmit);
		},
		
		render: function () {
			this.event.trigger("default");
			this.updateVisuals();
			
			this.content.render();
			
			return this;
		},
		
		updateVisuals: function() {
			//Determine whether to show the Add Position form button
			if(this.lgInstance.isCommissioner(this.userModel.get('userName')) 
					&& this.prodConfig.CUSTPOS == 'true'
					&& this.lgInstance.get("draftStatus") != "COMPLETED"
					&& this.prodType.get('active')){
				this.$("#addPosOpen").show();
			} else {
				this.$("#addPosOpen").hide();
			}
		},
		
		hideView: function() {
			this.event.trigger("resetMessages");
			this.$("#addPosOpen").show();
			this.$("#addPosBodyContent").slideUp();
		},
		
		showView: function() {
			this.$("#addPosOpen").hide();
			this.$("#addPosBodyContent").slideDown();
		},
		
		error: function(model, error) {
			if(this.submittedData.isSubmitted){
				model.destroy();
				
				if (error.status == 400) {
					//Input errors
					this.event.trigger("error");
					
					var errObj = JSON.parse(error.responseText);
					
					if(errObj.code){
						for(var i=0; i< errObj.code.length; i++){
							if(errObj.code[i].indexOf("_") > 0){
								//Trigger a specific event for the field with the code attached as a param
								var errCode = errObj.code[i].substring(0, errObj.code[i].indexOf("_"));
								var field = errObj.code[i].substring(errObj.code[i].indexOf("_") + 1);
								this.event.trigger("error:" + field.toLowerCase(), errCode);
							}
						}
					}
				} else {
					this.event.trigger("error");
				}
				
				this.submittedData.isSubmitted = false;
			}
		},
		
		success: function (model, response) {			
			if(this.submittedData.isSubmitted){
				this.submittedData.isSubmitted = false;
				//this.model.trigger("reset");
				this.lgInstance.get('leaguePositions').add(model);
				this.event.trigger("success");
			}

			this.$("#addPosOpen").show();
			this.$("#addPosBodyContent").hide();
		},
		
		formSubmit: function(e) {
			e.preventDefault();
			return false;
		},
		
		destroyView: function() {
	    	this.message.destroyView();
			this.content.destroyView();
			this.footer.destroyView();
	    	
	    	this.stopListening();
	    	this.undelegateEvents();
        }
	});
	
	return AddPositionView;  
});